import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { withRouter } from 'react-router-dom';

import { DefaultSheet } from 'twyne-new.ui';

import { useAppAlert } from '@Components/AppAlert';
import history from 'utils/history';

import Form from '../components/Form';
import { SubidProvider, useSubIdStore } from '../store';

const SubId = withRouter(({ match: { params: { id, allocationID } } }) => {
  const { collection: { useLoad, item, useSubmit } } = useSubIdStore()
  const { handleSuccess, handleError } = useAppAlert()

  useLoad(id)

  const handleSubmit = useSubmit()

  function handleClose() {
    history.goBack()
  }

  const handleSubmitAndClose = async payload => {
    try {
      await handleSubmit(payload)
      const message = payload.id ? 'edited' : 'created'
      handleSuccess('Success', `SubID ${message}.`);
      history.goBack()
    } catch {
      handleError('Error', 'SubID was not saved.');
    }
  }

  if (!item) return null

  return <DefaultSheet
    wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleClose() }}
    title={item.id ? 'Edit SubID' : 'Add SubID'}
  >
    <Helmet title="SubID" />
    <Form data={item} handleSubmit={handleSubmitAndClose} allocationID={allocationID} />
  </DefaultSheet>
})

SubId.propTypes = {
  match: PropTypes.object,
};

const SubidForm = withRouter(SubId);

export default function SubidFormLayout() {
  return <SubidProvider>
    <SubidForm />
  </SubidProvider>
}
